import React, { useEffect, useRef, useState } from 'react';
import { type Editor } from 'slate';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import ColorPicker from '../../../components/ColorPicker/ColorPicker';
import { ReactEditor } from 'slate-react';
import ColorUtils from '../../../util/color';
import classnames from 'classnames';

interface TableCellBackgroundColorToolbarComponentProps {
  editor: Editor;
  getBackgroundColor: () => string | undefined;
  setBackgroundColor: (color?: string) => void;
  active?: boolean;
  enabled?: boolean;
}

const TableCellBackgroundColorToolbarComponent: React.FC<
  TableCellBackgroundColorToolbarComponentProps
> = ({ editor, getBackgroundColor, setBackgroundColor, active, enabled }) => {
  const menuRef = useRef<HTMLElement>();
  const [currentColor, setCurrentColor] = useState(getBackgroundColor());

  useEffect(() => {
    setCurrentColor(getBackgroundColor());
  }, [editor, editor.selection]);

  const handleColorChange = (color: string, focusEditor?: boolean) => {
    const mappedColor = ColorUtils.mapColorFromColorPickerFromDarkMode(color);

    setBackgroundColor(mappedColor);
    setCurrentColor(mappedColor);

    if (focusEditor) {
      ReactEditor.focus(editor);
    }
  };

  const handleClearColor = () => {
    setBackgroundColor();
    setCurrentColor(undefined);
    ReactEditor.focus(editor);
  };

  return (
    <aha-menu ref={menuRef}>
      <div slot="control">
        <div
          className={styles.toolbarButton}
          aria-selected={active}
          aria-disabled={!enabled}
        >
          {currentColor ? (
            <span
              className={styles.cellBackgroundColorIcon}
              style={currentColor ? { backgroundColor: currentColor } : {}}
            />
          ) : (
            <span
              className={classnames(
                styles.cellBackgroundColorIcon,
                styles.colorIconNone
              )}
            />
          )}
        </div>
      </div>
      <aha-menu-content>
        <ColorPicker
          currentColor={currentColor ?? '#ffffff'}
          handleColorChange={handleColorChange}
          handleClearColor={handleClearColor}
          handleCloseMenu={() => menuRef.current?.removeAttribute('open')}
          showCustomColorInput
          showClearButton
        />
      </aha-menu-content>
    </aha-menu>
  );
};

export default TableCellBackgroundColorToolbarComponent;
